import { render, staticRenderFns } from "./goodStatus.vue?vue&type=template&id=518b1a9e&scoped=true"
import script from "./goodStatus.vue?vue&type=script&lang=js"
export * from "./goodStatus.vue?vue&type=script&lang=js"
import style0 from "./goodStatus.vue?vue&type=style&index=0&id=518b1a9e&prod&lang=stylus&scoped=true"
import style1 from "./goodStatus.vue?vue&type=style&index=1&id=518b1a9e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b1a9e",
  null
  
)

export default component.exports